import { useScreenSize } from "hooks";
import React from "react";
import Mobile from "./mobile";
import Desktop from "./desktop";

export default function RenderStaffPermission() {
  let staffPermission;
  const { isDesktop, isMobile } = useScreenSize();
  switch (true) {
    case isDesktop:
      staffPermission = <Desktop />;
      break;
    case isMobile:
      staffPermission = <Mobile />;
      break;
    default:
      staffPermission = <div></div>;
  }
  return staffPermission;
}
